import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CONTACT_EMAIL, CONTACT_PHONE } from "@/lib/brand";

const LAST_UPDATED = "17 July 2026";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <Header onCTA={() => (window.location.href = "/#contact")} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 prose prose-slate">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">Legal</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-slate-900 mb-2">Terms of Use</h1>
        <p className="text-sm text-slate-500 mb-10">Last updated: {LAST_UPDATED}</p>

        <Section title="1. About Loan81">
          Loan81 is a personal loan comparison and referral platform. We are not a bank, NBFC, or lender.
          We do not sanction, underwrite, or disburse loans. Loan81 helps you compare indicative rates and
          terms from partner banks/NBFCs and, where you request it, connects you with those lenders or our
          loan advisors.
        </Section>

        <Section title="2. Indicative information only">
          Interest rates, processing fees, eligibility criteria, and other figures shown on Loan81 are
          indicative, sourced from publicly available lender information, and subject to change at the
          relevant bank's/NBFC's sole discretion without notice. Final rates, eligibility, and approval are
          determined solely by the lender based on their own underwriting process. Loan81 does not guarantee
          loan approval, a specific interest rate, or any particular outcome.
        </Section>

        <Section title="3. No fee to borrowers">
          Loan81 does not charge borrowers any fee for using the comparison tool or for submitting an
          enquiry. We may receive a referral commission from partner banks/NBFCs when a loan is
          successfully disbursed through our platform; this does not affect the rate or terms offered to
          you.
        </Section>

        <Section title="4. Your responsibilities">
          You agree to provide accurate and truthful information when submitting an enquiry. You are
          responsible for reviewing and independently verifying all loan terms, conditions, and documentation
          directly with the lender before accepting any loan offer.
        </Section>

        <Section title="5. Consent to contact">
          By submitting an enquiry on Loan81, you consent to being contacted by Loan81 and/or relevant
          partner lenders via call, SMS, WhatsApp, or email regarding your enquiry, as described in our
          Privacy Policy.
        </Section>

        <Section title="6. No liability for lender decisions">
          Loan81 is not responsible for a lender's decision to approve, reject, delay, or modify the terms
          of any loan application, nor for any dispute arising between you and a lender. Any loan agreement
          is strictly between you and the lender.
        </Section>

        <Section title="7. Intellectual property">
          All content on this website, including text, design, and branding, is the property of Loan81 and
          may not be reproduced without permission, other than for your personal, non-commercial use of the
          site.
        </Section>

        <Section title="8. Changes to these terms">
          We may revise these Terms of Use from time to time. Continued use of Loan81 after changes are
          posted constitutes your acceptance of the revised terms.
        </Section>

        <Section title="9. Governing law">
          These terms are governed by the laws of India, and any disputes shall be subject to the exclusive
          jurisdiction of the courts at Delhi.
        </Section>

        <Section title="10. Contact us">
          For any questions about these terms, write to us at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-emerald-600 font-medium">{CONTACT_EMAIL}</a>{" "}
          or call {CONTACT_PHONE}.
        </Section>
      </div>
      <Footer />
    </div>
  );
}

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
    <p className="text-slate-600 leading-relaxed text-[15px]">{children}</p>
  </div>
);
